import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { getImpMail, setImpMail, saveImpMail, deleteImpMail } from '../actions/mailinfo.actions';

@Injectable()
export class MailInfoEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private router = inject(Router);

  getImpMail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getImpMail),
        map((action: any) =>
          this.baseService[action.apiConstants?.method](action.apiConstants, action.params).subscribe((res: any) => {
            if (res) {
              this.store.dispatch(
                setImpMail({
                  impMail: res
                })
              );
            } else {
              this.store.dispatch(
                setImpMail({
                  impMail: { sid: null }
                })
              );
            }
          })
        )
      ),
    {
      dispatch: false
    }
  );

  saveImpMail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveImpMail),
        map((action) =>
          this.baseService[action.apiConstants?.method](action.apiConstants, action.impMailData).subscribe()
        )
      ),
    { dispatch: false }
  );

  deleteImpMail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteImpMail),
        map((action) => this.baseService[action.apiConstants?.method](action.apiConstants, action.ids).subscribe())
      ),
    { dispatch: false }
  );
}
